import CodeRenderer from './CodeRenderer';
import LinkRenderer from './LinkRenderer';
import TextRenderer from './TextRenderer';

export default { CodeRenderer, LinkRenderer, TextRenderer };
